var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDecisao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_168",
    transform: "translate(25.215 4) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.7,
    y: 2.7,
    transform: "matrix(2.535182e-06 1 -1 2.535182e-06 19.799 10.2035)",
    className: "st0",
    width: 25,
    height: 24.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.3,
    y: 3.1,
    transform: "matrix(2.535181e-06 1 -1 2.535181e-06 19.799 10.2035)",
    className: "st1",
    width: 24.1,
    height: 23.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDecisao01);
export default __webpack_public_path__ + "static/media/ico-decisao-01.b42889cc5ec4965c1d17f93fdfb2c3f4.svg";
export { ForwardRef as ReactComponent };